import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import appErrorService from '../../services/app/appErrorService';
import uiMessageRequestService from '../../services/iot/uiMessageRequestService';
import {makeSelectIsYapFirmwareInProgress} from '../../state/selectors/yapEncrypted';
import helpers from '../../utils/helpers';
import {IFwuInfo} from './useFWUInfoLoaded';

interface IProps {
    fwuInfo?: IFwuInfo;
    forceCheck?: boolean;
    showGlobalError?: boolean;
    onError?: () => void;
}

const usePublishCheckFirmware = (props: IProps): void => {
    const {fwuInfo, forceCheck, showGlobalError, onError} = props;
    const isYapFirmwareInProgress = useSelector(makeSelectIsYapFirmwareInProgress());
    const deps = forceCheck ? [] : [fwuInfo?.isLoaded, isYapFirmwareInProgress];

    const startCheck = async () => {
        const result = await uiMessageRequestService().publishCheckFirmwareMessage(fwuInfo!.fwuTarget);

        if (!result) {
            helpers.runFunction(onError);
            if (showGlobalError) {
                appErrorService.showGlobalErrorWithAppReset();
            }
        }
    };

    useEffect(() => {
        const isCheckingNeeded =
            fwuInfo && !fwuInfo.isAvailable && fwuInfo.fwuTarget && (!fwuInfo.isLoaded || forceCheck);

        if (isCheckingNeeded && !isYapFirmwareInProgress) {
            startCheck();
        }
    }, deps);
};

export default usePublishCheckFirmware;
